import React from 'react';
import {
  Box,
  Button,
  Paper,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Security as SecurityIcon,
  ExitToApp as ExitIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
// import { logger } from "../../utils/logger";
const ImpersonationBanner: React.FC = () => {
  const { stopImpersonation, user } = useAuth();
  const [dismissed, setDismissed] = React.useState(false);
  
  // Check if user is in impersonation mode from session data
  const isInImpersonationMode = user?.is_impersonation === true;

  if (!isInImpersonationMode || dismissed) {
    return null;
  }

  const handleExitImpersonation = async () => {
    if (confirm('Are you sure you want to exit impersonation mode? You will be redirected back to the admin panel.')) {
      await stopImpersonation();
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  // Get impersonated user info for display
  const impersonatedUserName = user?.first_name && user?.last_name 
    ? `${user.first_name} ${user.last_name}` 
    : user?.email || 'User';

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 9999,
        p: 2,
        backgroundColor: 'warning.light',
        border: '2px solid',
        borderColor: 'warning.main',
        borderRadius: 2,
        minWidth: 300,
        maxWidth: 400,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <SecurityIcon sx={{ color: 'warning.main', mt: 0.5 }} />
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'warning.dark', mb: 0.5 }}>
            Impersonation Mode Active
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
            You are viewing as: <strong>{impersonatedUserName}</strong>
          </Typography>
          <Button
            variant="contained"
            color="warning"
            size="small"
            startIcon={<ExitIcon />}
            onClick={handleExitImpersonation}
            sx={{ mr: 1 }}
          >
            Exit Impersonation
          </Button>
        </Box>
        <IconButton
          size="small"
          onClick={handleDismiss}
          aria-label="Dismiss impersonation banner"
          sx={{
            color: 'text.secondary',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
          }}
        >
          <CloseIcon fontSize="small" aria-hidden />
        </IconButton>
      </Box>
    </Paper>
  );
};

export default ImpersonationBanner;

